import { useGetGuide, type RefundInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Center, Spinner, Td, Text, Th, Tr } from "@chakra-ui/react";
import { CustomTable, CustomTitle } from "./refund.style";

export const Refund = () => {
    const { data } = useGetGuide<RefundInfoResponse>({ section: "refund" });
    const currentRefunds = data?.currentRefunds;
    const EMPTY_GROUP = Array.from({ length: 2 });
    const { isTablet } = MEDIA();

    return data ? (
        <Center as="section" p="0 20px" flexDir="column" rowGap={isTablet ? "32px" : "64px"}>
            <Center flexDir="column">
                <CustomTitle fontFamily="Cormorant">Pension Refund</CustomTitle>
                <Text fontFamily="Cormorant">환불 규정</Text>
            </Center>
            <Center w="100%" overflow={isTablet ? "auto" : ""} justifyContent={isTablet ? "flex-start" : "center"}>
                <CustomTable>
                    {EMPTY_GROUP.flatMap((_, trIdx) => (
                        <Tr>
                            {trIdx === 0 &&
                                currentRefunds?.map(
                                    (refund, idx) =>
                                        idx > 0 && <Th key={refund.beforeDate}>숙박 {refund.beforeDate}일전</Th>,
                                )}
                            {trIdx === 1 &&
                                currentRefunds?.map(
                                    (refund, idx) => idx > 0 && <Td key={refund.refund}>{refund.refund} 환불</Td>,
                                )}
                        </Tr>
                    ))}
                </CustomTable>
            </Center>
        </Center>
    ) : (
        <Spinner />
    );
};
